export default {
  '--step-content-color': 'rgba(255, 255, 255, .38)',
  '--step-content-active-color': '#fff',
  '--step-line-background': '#fff'
};